
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import apiCalls from 'src/api/apiCalls';
import { Button, Spin } from 'antd';
import ErrorMessage from 'src/components/shared/messages/errorMessage';
const PersonalDetailView = () => {
  const navigate = useNavigate()
  const { custId, personalDetailId } = useParams()
  const [localState,setLocalState]=useState({details:null,loader:false,error:''})
  useEffect(() => {
    getPersonalDetails()
  }, [])

  const getPersonalDetails = async () => {
    setLocalState(state=>({...state,loader:true}))
    try {
      let response = await apiCalls.getCustomerPersonalInfo(`Address/${personalDetailId}`);
      if (response.status === 200) {
        setLocalState(state=>({...state,details:response.data}))
        localState.error && setLocalState(state=>({...state,error:''}))
      }
      else {
        setLocalState(state=>({...state,error:apiCalls.isErrorDispaly(response)}))
      }
    }
    catch (error) {
      setLocalState(state=>({...state,error:apiCalls.isErrorDispaly(error)}))
    } finally {
      setLocalState(state=>({...state,loader:false}))
    }
  }
  const navigateToGrid = () => {
    navigate(`/customer/${custId}/Personal Information`)
  }
  return (
    <div>
      {localState.error && <ErrorMessage msg={localState.error} onClose={() => setLocalState(state=>({...state,error:''}))} />}
      <Spin spinning={localState.loader}>
        {localState.details && <>
          <div className="bg-light-cardBg grid lg:grid-cols-3 gap-4 border border-light-cardBorder rounded-lg p-4 mb-7 drop-shadow-sm">
            <div>
              <p className="mb-0 text-light-labelColor">First Name {localState.details?.isDefault && <span className='status-badge ms-2 bg-light-badgeGreen px-2 rounded-md text-xs  text-[#fff]'>Default</span>}</p>
              <p className="mb-0 text-light-valueColor font-medium">
                {localState.details?.firstname || "--"}
              </p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">Last Name</p>
              <p className="mb-0 text-light-valueColor font-medium">
                {localState.details?.lastname || "--"}
              </p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">Email</p>
              <p className="mb-0 text-light-valueColor font-medium">{localState.details?.email ?? "--"}</p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">Phone No</p>
             {(localState.details?.phoneCode && localState.details?.phoneNumber) && <p className="mb-0 text-light-valueColor font-medium">{localState.details?.phoneCode+" "+localState.details?.phoneNumber || "--"}</p>}
             {(!localState.details?.phoneCode && localState.details?.phoneNumber) && <p className="mb-0 text-light-valueColor font-medium">{localState.details?.phoneNumber}</p>}
             {(!localState.details?.phoneCode && !localState.details?.phoneNumber) && <p className="mb-0 text-light-valueColor font-medium">{"--"}</p>}
            </div>

            <div>
              <p className="mb-0 text-light-labelColor">Address Line 1</p>
              <p className="mb-0 text-light-valueColor font-medium">
                {localState.details?.addressLine1 || '--'}
              </p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">Address Line 2</p>
              <p className="mb-0 text-light-valueColor font-medium">
                {localState.details?.addressLine2 || '--'}
              </p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">City</p>
              <p className="mb-0 text-light-valueColor font-medium">{localState.details?.city || "--"}</p>
            </div>

            <div>
              <p className="mb-0 text-light-labelColor">State</p>
              <p className="mb-0 text-light-valueColor font-medium">{localState.details?.state || "--"}</p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">Country</p>
              <p className="mb-0 text-light-valueColor font-medium">{localState.details?.country || "--"}</p>
            </div>
            <div>
              <p className="mb-0 text-light-labelColor">Postal Code</p>
              <p className="mb-0 text-light-valueColor font-medium">{localState.details?.postalCode || "--"}</p>
            </div>
          </div>
          <div className='text-right mt-4'> <Button type='primary' onClick={navigateToGrid} className='primary-btn cancel-btn'>Back</Button></div>
        </>}

      </Spin>
    </div>
  )
}

export default PersonalDetailView